const state = {
    loading: '',
    options: {
        color: 'grey',
        size: '90px'
    }
}

const getters = {
    getLoaderStatus: (state) => {
        return state.loading
    },
    getOptions: (state) => {
        return state.options
    }
}

const actions = {
    setStatusLoading: ({ commit }) => {
        commit('changeLoadingStatus', true)
    },
    setStatusLoaded: ({ commit }) => {
        commit('changeLoadingStatus', false)
    }
}

const mutations = {
    changeLoadingStatus: (state, newStatus) => {
        state.loading = newStatus
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/loader.js